<template>
  <div class="">
    <div
      v-if="assignedFilterExtension && assignedFilterExtension.length"
      class="flex gap-2 pt-1"
    >
      <span
        v-for="search in assignedFilterExtension"
        :key="search"
        class="inline-flex items-center rounded-full bg-gray-200 py-0.5 pl-2.5 pr-1 text-sm font-medium text-gray-700"
      >
        {{ search }}
        <button
          type="button"
          @click="
            assignedFilterExtension && assignedFilterExtension.length > 1
              ? assignedFilterExtension.splice(
                  assignedFilterExtension.indexOf(search),
                  1
                )
              : ((assignedFilterExtension.length = 0),
                this.$emit('update:searchExtension', null))
          "
          class="ml-0.5 inline-flex h-4 w-4 flex-shrink-0 items-center justify-center rounded-full text-gray-400 hover:bg-gray-200 hover:text-gray-500 focus:bg-gray-500 focus:text-white focus:outline-none"
        >
          <svg
            class="h-2 w-2"
            stroke="currentColor"
            fill="none"
            viewBox="0 0 8 8"
          >
            <path
              stroke-linecap="round"
              stroke-width="1.5"
              d="M1 1l6 6m0-6L1 7"
            />
          </svg>
        </button>
      </span>
    </div>
  </div>
  <div class="flex flex-col">
    <div class="overflow-x-auto">
      <div class="inline-block min-w-full align-middle py-2 px-2">
        <div
          class="relative overflow-hidden shadow-md ring-1 ring-black ring-opacity-5 md:rounded-lg"
        >
          <table
            v-if="tableData && tableData.length"
            class="min-w-full divide-y divide-gray-300 dark:divide-slate-400 h-96"
          >
            <thead class="bg-gray-50 dark:bg-slate-700">
              <!-- Header row 1: group headers -->
              <tr>
                <!-- Utilisateur with filter (rowspan=2) -->
                <th
                  rowspan="2"
                  scope="col"
                  class="px-2 py-3 text-center text-sm font-semibold align-middle"
                >
                  <div class="w-28 text-center">
                    <div as="div" class="mt-0">
                      <div class="flex text-center justify-center">
                        <button
                          class="flex text-center justify-center items-center text-sm font-semibold capitalize"
                          @focus="openExtensionFilter = true"
                          @blur="openExtensionFilter = false"
                          @click="focusInputExtension()"
                        >
                          {{ $t("user") }}
                          <FilterIcon
                            class="flex-shrink-0 mt-0.5 h-3 w-3 hover:text-gray-500"
                            aria-hidden="true"
                          />
                        </button>
                      </div>
                      <transition
                        enter-active-class="transition ease-out duration-100"
                        enter-from-class="transform opacity-0 scale-95"
                        enter-to-class="transform opacity-100 scale-100"
                        leave-active-class="transition ease-in duration-75"
                        leave-from-class="transform opacity-100 scale-100"
                        leave-to-class="transform opacity-0 scale-95"
                      >
                        <div
                          @mouseover="
                            (openExtensionFilterFocus = true),
                              (isMouseOverFilter = true)
                          "
                          @mouseleave="
                            (isMouseOverFilter = false),
                              (openExtensionFilterFocus = false)
                          "
                          v-show="openExtensionFilter || openExtensionFilterFocus"
                          class="rounded origin-top-left absolute mt-2 w-auto shadow-2xl body__header--menu ring-1 ring-black ring-opacity-5 focus:outline-none z-1"
                        >
                          <div
                            class="mt-1 mb-1 mx-1 rounded-md px-3 py-2 shadow-sm text-gray-800"
                          >
                            <div class="relative">
                              <div
                                class="pointer-events-none absolute inset-y-0 left-0 pl-3 flex items-center z-2"
                              >
                                <SearchIcon
                                  class="h-5 w-5 text-gray-400"
                                  aria-hidden="true"
                                />
                              </div>
                              <vue-select
                                @focus="
                                  (openExtensionFilter = true),
                                    (openExtensionFilterFocus = true)
                                "
                                @blur="openExtensionFilter = false"
                                v-model="assignedFilterExtension"
                                multiple
                                :options="extensionsNameNumberArray"
                                maxHeight="200"
                                close-on-select="true"
                                searchable
                                :class="[
                                  'block w-full bg-white py-1 pl-10 pr-3 text-sm sm:text-sm z-1',
                                ]"
                                ref="inputSearchExtension"
                              >
                              </vue-select>
                            </div>
                          </div>
                        </div>
                      </transition>
                    </div>
                  </div>
                </th>
                <th
                  colspan="3"
                  scope="col"
                  class="px-2 py-3 text-center text-sm font-semibold border-r border-gray-200"
                >
                  {{ $t("connexionsHeader") }}
                </th>
                <th
                  colspan="5"
                  scope="col"
                  class="px-2 py-3 text-center text-sm font-semibold border-r border-gray-200"
                >
                  {{ $t("statusDistributionHeader") }}
                </th>
                <th
                  rowspan="2"
                  scope="col"
                  class="px-2 py-3 text-center text-sm font-semibold align-middle cursor-help"
                  :title="$t('availableOutOfCallTooltip')"
                >
                  {{ $t("availableOutOfCall") }}
                </th>
              </tr>
              <!-- Header row 2: subheaders -->
              <tr>
                <th
                  scope="col"
                  class="px-2 py-3 text-center text-sm font-semibold"
                >
                  {{ $t("loginTimeHeader") }}
                </th>
                <th
                  scope="col"
                  class="px-2 py-3 text-center text-sm font-semibold"
                >
                  {{ $t("logoutTimeHeader") }}
                </th>
                <th
                  scope="col"
                  class="px-2 py-3 text-center text-sm font-semibold border-r border-gray-200"
                >
                  {{ $t("totalConnectionDuration") }}
                </th>
                <th
                  scope="col"
                  class="px-2 py-3 text-center text-sm font-semibold"
                >
                  {{ $t("available") }}
                </th>
                <th
                  scope="col"
                  class="px-2 py-3 text-center text-sm font-semibold"
                >
                  {{ $t("away") }}
                </th>
                <th
                  scope="col"
                  class="px-2 py-3 text-center text-sm font-semibold"
                >
                  {{ $t("dnd") }}
                </th>
                <th
                  scope="col"
                  class="px-2 py-3 text-center text-sm font-semibold"
                >
                  {{ pbx3cxAgentConfig?.status_custom1 }}
                </th>
                <th
                  scope="col"
                  class="px-2 py-3 text-center text-sm font-semibold border-r border-gray-200"
                >
                  {{ pbx3cxAgentConfig?.status_custom2 }}
                </th>
              </tr>
            </thead>
            <tbody
              class="divide-y divide-gray-200 bg-white dark:bg-slate-500 dark:divide-slate-400"
            >
              <tr
                v-for="data in tableData"
                :key="data.user"
                class="hover:bg-slate-100 dark:hover:bg-slate-400"
              >
                <!-- Utilisateur -->
                <td class="whitespace-nowrap px-2 py-3 text-sm text-center">
                  {{ data.user }}
                </td>

                <!-- Connexion de (single day only) -->
                <td class="whitespace-nowrap px-2 py-3 text-sm text-center">
                  {{ isSingleDay ? data.login_time ?? "-" : "-" }}
                </td>

                <!-- Déconnexion à (single day only) -->
                <td class="whitespace-nowrap px-2 py-3 text-sm text-center">
                  {{ isSingleDay ? data.logout_time ?? "-" : "-" }}
                </td>

                <!-- Durée Connexion Totale -->
                <td
                  class="whitespace-nowrap px-2 py-3 text-sm text-center border-r border-gray-200 dark:border-slate-400"
                >
                  {{ minutesToHHMM(data.status_summary?.total_active_minutes) }}
                </td>

                <!-- Disponible -->
                <td class="whitespace-nowrap px-2 py-3 text-sm text-center">
                  {{ minutesToHHMM(data.status_summary?.available_minutes) }}
                </td>

                <!-- Absent -->
                <td class="whitespace-nowrap px-2 py-3 text-sm text-center">
                  {{ minutesToHHMM(data.status_summary?.away_minutes) }}
                </td>

                <!-- Ne pas déranger -->
                <td class="whitespace-nowrap px-2 py-3 text-sm text-center">
                  {{ minutesToHHMM(data.status_summary?.dnd_minutes) }}
                </td>

                <!-- custom_1 -->
                <td class="whitespace-nowrap px-2 py-3 text-sm text-center">
                  {{ minutesToHHMM(data.status_summary?.custom_1_minutes) }}
                </td>

                <!-- custom_2 -->
                <td
                  class="whitespace-nowrap px-2 py-3 text-sm text-center border-r border-gray-200 dark:border-slate-400"
                >
                  {{ minutesToHHMM(data.status_summary?.custom_2_minutes) }}
                </td>

                <!-- Disponible hors appel -->
                <td class="whitespace-nowrap px-2 py-3 text-sm text-center">
                  {{ availableOutOfCallTime(data) }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueSelect from "vue-next-select";
import "vue-next-select/dist/index.css";
import { FilterIcon, SearchIcon } from "@heroicons/vue/outline";
import { mapGetters } from "vuex/dist/vuex.cjs.js";

export default {
  components: { VueSelect, FilterIcon, SearchIcon },
  props: {
    tableData: {
      type: Array,
      default: () => [],
    },
    startDate: {
      type: String,
      default: null,
    },
    endDate: {
      type: String,
      default: null,
    },
    searchExtension: {
      type: Array,
      default: null,
    },
    extensionsNameNumberArray: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      assignedFilterExtension: [],
      openExtensionFilter: false,
      openExtensionFilterFocus: false,
      isMouseOverFilter: false,
    };
  },
  computed: {
    ...mapGetters(["pbx3cxAgentConfig"]),
    isSingleDay() {
      return this.startDate && this.endDate && this.startDate === this.endDate;
    },
  },
  methods: {
    focusInputExtension() {
      if (this.$refs.inputSearchExtension) {
        this.$refs.inputSearchExtension[0].focus();
      }
    },
    minutesToHHMM(minutes) {
      if (minutes == null) return "-";
      const total = parseInt(minutes, 10);
      if (isNaN(total)) return "-";
      const h = Math.floor(total / 60);
      const m = total % 60;
      return `${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")}`;
    },
    availableOutOfCallTime(row) {
      const availableMinutes = parseInt(
        row.status_summary?.available_minutes,
        10
      );
      const durationSeconds = parseInt(row.duration_total, 10);
      if (isNaN(availableMinutes) || isNaN(durationSeconds)) return "-";
      const result = availableMinutes - Math.floor(durationSeconds / 60);
      return this.minutesToHHMM(Math.max(0, result));
    },
  },
  watch: {
    assignedFilterExtension(val) {
      if (val && val.length > 0) {
        this.$emit("update:searchExtension", val);
      } else {
        this.$emit("update:searchExtension", null);
      }
    },
  },
  mounted() {
    if (this.searchExtension) {
      this.assignedFilterExtension = this.searchExtension;
    }
  },
};
</script>
